import axios from 'axios';

const ENV_API = `${process.env.REACT_APP_BACKEND_SERVER}/api/enroll`;

function enrollBases() {
  const bases = [];
  if (typeof window !== 'undefined' && window.location.pathname.startsWith('/enroll')) {
    bases.push('/api/enroll');
  }
  if (ENV_API && !bases.includes(ENV_API)) bases.push(ENV_API);
  return bases.length ? bases : [ENV_API];
}

let lastEnrollBase = '';

async function enrollRequest(config) {
  const bases = enrollBases();
  let lastErr;
  for (let i = 0; i < bases.length; i += 1) {
    try {
      const result = await axios({
        ...config,
        url: `${bases[i]}${config.url}`,
        withCredentials: true,
      });
      lastEnrollBase = bases[i];
      return result;
    } catch (err) {
      lastErr = err;
      const status = err.response?.status;
      const canFallback = i < bases.length - 1 && (!err.response || status === 404);
      if (!canFallback) throw err;
    }
  }
  throw lastErr;
}

export function enrollProfileUrl(token) {
  const onEnrollPage = typeof window !== 'undefined' && window.location.pathname.startsWith('/enroll');
  const base = lastEnrollBase || (onEnrollPage ? '/api/enroll' : ENV_API);
  const access = token || (typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('enrollDirectoryToken') : '');
  const url = `${base}/profile`;
  if (!access) return url;
  return `${url}?token=${encodeURIComponent(access)}`;
}

export function enrollBannerUrl({ profile, serial, udid, location, rev } = {}) {
  const params = new URLSearchParams();
  if (profile) params.set('profile', profile);
  if (serial) params.set('serial', serial);
  if (udid) params.set('udid', udid);
  if (location) params.set('location', location);
  if (rev) params.set('v', String(rev));
  const query = params.toString() ? `?${params}` : '';
  const onEnrollPage = typeof window !== 'undefined' && window.location.pathname.startsWith('/enroll');
  const base = lastEnrollBase || (onEnrollPage ? '/api/enroll' : ENV_API);
  return `${base}/banner${query}`;
}

const getConsoleHeader = () => {
  const tokenStr = localStorage.getItem('user');
  if (!tokenStr) return {};
  try {
    const token = JSON.parse(tokenStr).token;
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
};

const getDirectoryHeader = () => {
  const token = sessionStorage.getItem('enrollDirectoryToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export async function getEnrollSplash({ profile, serial, udid } = {}) {
  const params = {};
  if (profile) params.profile = profile;
  if (serial) params.serial = serial;
  if (udid) params.udid = udid;
  const { data } = await enrollRequest({ method: 'get', url: '/splash', params });
  return data;
}

export async function loginDirectoryEnrollment({ username, password, serialNumber, udid, profile }) {
  const { data } = await enrollRequest({
    method: 'post',
    url: '/directory-login',
    data: {
      username,
      password,
      serialNumber: serialNumber || undefined,
      udid: udid || undefined,
      profile: profile || undefined,
    },
  });
  if (data?.token) sessionStorage.setItem('enrollDirectoryToken', data.token);
  return data;
}

export function logoutDirectoryEnrollment() {
  sessionStorage.removeItem('enrollDirectoryToken');
}

export async function listPendingEnrollmentDevices() {
  const { data } = await enrollRequest({
    method: 'get',
    url: '/pending-devices',
    headers: getDirectoryHeader(),
  });
  return data;
}

export async function assignDirectoryUserToDevice({ serialNumber, udid, profile } = {}) {
  const { data } = await enrollRequest({
    method: 'post',
    url: '/assign',
    data: { serialNumber, udid, profile },
    headers: { ...getDirectoryHeader(), 'Content-Type': 'application/json' },
  });
  return data;
}

export async function authorizeEnrollment(serialNumber) {
  const { data } = await axios.post(
    `${ENV_API}/authorize`,
    { serialNumber },
    { headers: { ...getConsoleHeader(), 'Content-Type': 'application/json' } }
  );
  return data;
}

export async function continueAdeSetup({ serialNumber, udid, profile } = {}) {
  const { data } = await enrollRequest({
    method: 'post',
    url: '/continue-setup',
    data: {
      serialNumber: serialNumber || undefined,
      udid: udid || undefined,
      profile: profile || undefined,
    },
  });
  return data;
}

export async function continueConfiguredSetup(serialNumber) {
  const { data } = await axios.post(
    `${ENV_API}/device-configured`,
    { serialNumber },
    { headers: { ...getConsoleHeader(), 'Content-Type': 'application/json' } }
  );
  return data;
}
